/** @format */
import { NavLink, useResolvedPath, useMatch } from "react-router-dom";

function CustomLink({ children, to, className, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });
  return (
    <div>
      <NavLink
        className={({ isActive }) => {
          return isActive || match ? `${className} active` : `${className}`;
        }}
        to={to}
        {...props}
      >
        {children}
      </NavLink>
    </div>
  );
}

export default CustomLink;
